module.exports = __webpack_public_path__ + "media/reportAssets/WorkingWithAcademia-6c70cb09.jpg";